import * as Yup from "yup";

const teamName = Yup
	.string()
	.required("Team name is required");

const email = Yup
	.string()
	.email("Invalid email address");

const title = Yup
	.string()
	.required("Title is required");

const description = Yup
	.string()
	.required("Description is required");

const category = Yup
	.string()
	.required("You should add the task into a category");

const subcategory = Yup
	.string()
	.required("You should add the task into a subcategory");

const openAt = Yup
	.string()
	.required("You should define when the task will be open");

const closeAt = Yup
	.string()
	.required("You should define when the task will be closed");

const goalDSLModel = Yup
	.string()
	.required("You should define the goal DSL model");

const categoryName = Yup
	.string()
	.required("Category name is required");

const subcategoryName = Yup
	.string()
	.required("Subcategory name is required");

const url = Yup
	.string()
	.required("URL is required");

const schemas = {
	teamCreation: Yup.object({
		name: teamName,
		user2: email,
		user3: email,
		user4: email,
		user5: email,
	}),
	teamCreationAdmin: Yup.object({
		name: teamName,
		user1: email,
		user2: email,
		user3: email,
		user4: email,
		user5: email,
	}),
	addMember: Yup.object({
		email: email.required("Email is required"),
	}),
	teamName: Yup.object({
		name: teamName,
	}),
	taskCreation: Yup.object({
		title,
		category,
		subcategory,
		openAt,
		closeAt,
		goalDSLModel,
	}),
	categoryName: Yup.object({
		name: categoryName,
	}),
	subcategoryName: Yup.object({
		name: subcategoryName,
	}),
	addSubmission: Yup.object({
		description,
		url,
	}),
	dates: Yup.object({
		openAt,
		closeAt,
	}),
};

export default schemas;
